import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Dynamically swap the PWA manifest + theme-color + apple-touch-icon so that
 * users installing from `/home*` (Home Edition) get a distinct homescreen
 * icon + standalone app from users installing from `/` (Boat Edition).
 *
 * iOS reads <link rel="apple-touch-icon"> at install time.
 * Android reads <link rel="manifest"> + <meta name="theme-color">.
 */
export default function PWAManifestSwitcher() {
  const location = useLocation();

  useEffect(() => {
    // Decide edition based on URL or localStorage preference
    const path = location.pathname || "/";
    const urlParams = new URLSearchParams(location.search);
    const pwaParam = urlParams.get("pwa");
    let edition = "boat";
    if (pwaParam === "home" || pwaParam === "boat") {
      edition = pwaParam;
    } else if (path.startsWith("/home") || path.startsWith("/household") || path.startsWith("/admin/home")) {
      edition = "home";
    } else {
      const pref = (typeof window !== "undefined" && window.localStorage?.getItem("preferred_edition")) || "";
      if (pref === "household" || pref === "home") edition = "home";
    }

    const isHome = edition === "home";

    // Swap manifest
    const manifestEl = document.querySelector('link[rel="manifest"]');
    if (manifestEl) {
      const next = isHome ? "/manifest-home.json" : "/manifest-boat.json";
      if (manifestEl.getAttribute("href") !== next) manifestEl.setAttribute("href", next);
    }

    // Swap theme-color
    const themeEl = document.querySelector('meta[name="theme-color"]');
    if (themeEl) {
      themeEl.setAttribute("content", isHome ? "#92400e" : "#1e293b");
    }

    // Swap apple-touch-icon (iOS homescreen)
    const appleEl = document.querySelector('link[rel="apple-touch-icon"]');
    if (appleEl) {
      appleEl.setAttribute("href", isHome ? "/icons/home-edition-192.png" : "/icons/apple-touch-icon.png");
    }

    // Swap apple-mobile-web-app-title (iOS standalone app name)
    const titleEl = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (titleEl) {
      titleEl.setAttribute("content", isHome ? "PantryBuddy Hjem" : "PantryBuddy Båt");
    }
  }, [location.pathname, location.search]);

  return null;
}
